/**
 * 判断当前环境是否为期货通PC客户端
 * 
 * 通过检测 window.external.IsQhtWin 方法来判断是否为期货通PC客户端
 * 
 * @returns {boolean} 如果是期货通PC客户端返回 true，否则返回 false
 * 
 * @example
 * ```ts
 * import { isFuturesPcClient } from '@fu/matrix';
 * 
 * if (isFuturesPcClient()) {
 *   // 在期货通PC客户端中的处理逻辑
 *   console.log('当前在期货通PC客户端中');
 * }
 * ```
 * 
 * @since 1.0.0
 */
export function isFuturesPcClient(): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    }
    
    return Boolean(window.external && 'IsQhtWin' in window.external);
  } catch (error) {
    console.warn('检测期货通PC客户端失败:', error);
    return false;
  }
}
